// extracted by mini-css-extract-plugin
export default {"wrapper":"CC-z","viewport":"DC-z","container":"EC-z","slide":"FC-z"};